import { FormType } from '../FormWidget.types';
import ShortQuestion from './ShortQuestion';

export const FORM_TYPE_MAP = {
  [FormType.ShortQuestion]: ShortQuestion,
};
